import { render } from "./reviewCard.vue?vue&type=template&id=6603c0ec"
import script from "./reviewCard.vue?vue&type=script&lang=js"
export * from "./reviewCard.vue?vue&type=script&lang=js"

import "./reviewCard.vue?vue&type=style&index=0&id=6603c0ec&lang=scss"

import exportComponent from "/home/runner/work/cinema_vue/cinema_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__